import { render } from "./homePage.vue?vue&type=template&id=5d663f96&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"

import "./homePage.vue?vue&type=style&index=0&id=5d663f96&lang=less&scoped=true"
import "./homePage.vue?vue&type=style&index=1&id=5d663f96&lang=css"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d663f96"]])

export default __exports__